import { Component, ElementRef, HostBinding, Input, ViewChild } from '@angular/core';
import { MeasureVO } from '@wizeoo/akm-compute-lib';
import { IWizItemRenderer, WizLabel, WizBaseCollector, WizEventManager } from '@wizeoo/akm-component-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';

/** Renderer vignette d'une mesure */
@Component({
  selector: 'vision-measure-renderer',
  templateUrl: './vision-measure.renderer.html',
})
export class VisionMeasureRenderer implements IWizItemRenderer<null, MeasureVO> {
  constructor(public elementRef: ElementRef) {}

  @HostBinding('class.thumb') public thumb: boolean = true;

  @ViewChild('lbTitle') lbTitle: WizLabel;
  @ViewChild('lbContent') lbContent: WizLabel;

  // public showPen: boolean = false; // affichage du crayon d'édition, si éditable et mode I
  // public showWeight: boolean = false; // affichage du poids si WeightGrid
  // public showConstant: boolean = false; // affichage si constante
  public currentLabel: string = '';
  public currentFormula: string = '';
  // public currentMode: string = FormulaCoreEngine.MEASURE_MODE_INTERACT;

  public hasError(): boolean {
    if (this.data) {
      return this.data.hasError;
    }
    return false;
  }

  owner: WizBaseCollector;

  private _data: MeasureVO;
  public get data(): MeasureVO {
    return this._data;
  }
  @Input()
  public set data(data: MeasureVO) {
    this._data = data;
    this.currentLabel = this.data.trsLabel;
    this.currentFormula = this.data.shortCode;
  }


  public doAdd(e: Event): void {
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.ADD_MEASURE, this.data));
  }

}
